import { Stack } from "expo-router";
import { StatusBar } from "expo-status-bar";

export default function AuthLayout() {
  return (
    <>
      <StatusBar />
      <Stack>
        <Stack.Screen name="login" options={{ headerShown: false }} />
        <Stack.Screen
          name="login-with-email"
          options={{
            title: "Login",
            presentation: "formSheet",
            sheetAllowedDetents: "fitToContents", // all | medium | large, defaults to large
            sheetGrabberVisible: true,
          }}
        />
        <Stack.Screen
          name="recovery"
          // options={{
          //   title: "Account recovery",
          //   presentation: "formSheet",
          //   sheetAllowedDetents: "all",
          //   sheetGrabberVisible: true,
          // }}
        />
        <Stack.Screen name="token" options={{ headerShown: false }} />
      </Stack>
    </>
  );
}
